import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdTile from '../product_revamp/ad_tile';
import HttpRequestStore from '../../stores/http_request_store';
import ShippingFees from '../product_revamp/tile/shipping_fees';
import { allowShippingQuoteOnStore } from '../../../_views/shipping_quote/common';
import ProductBatchStocksStore from '../../stores/product_batch_stocks/product_batch_stocks_store';
import shippingAdFeesStore from '../../stores/shipping_ad_fees_store';

const { store } = TYROOLA.globals;

class CatalogAds extends Component {
  constructor() {
    super();
    this.state = {
      shippingData: shippingAdFeesStore.getState(),
      shippingDataLength: shippingAdFeesStore.getState().length,
      httpRequestStore: HttpRequestStore.getState(),
      productBatchStocksState: ProductBatchStocksStore.getState(),
    };
  }

  componentDidMount() {
    if (allowShippingQuoteOnStore(store)) {
      shippingAdFeesStore.addListener(() => this._getShippingStore());
      HttpRequestStore.addListener(() => this._getHttpRequestStore());
      ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
    }

    if (location.href.indexOf('disableDriverReviews=1') === -1) {
      let counter = 1;
      let clearIntervalFn1 = setInterval(() => {
        const isDrAvailable = document.querySelectorAll('#catalog-revamp-ads-container .driverreviews-widget');
        if ((window.driverreviews && isDrAvailable.length) || counter >= 200) {
          clearInterval(clearIntervalFn1);
          window.driverreviews && window.driverreviews.refreshWidgets();
        }
        counter += 1;
      }, 800);
    }
  }

  componentWillUnmount() {
    shippingAdFeesStore.addListener(() => this._getShippingStore());
    HttpRequestStore.addListener(() => this._getHttpRequestStore());
    ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
  }

  _getShippingStore() {
    this.setState({
      shippingData: shippingAdFeesStore.getState(),
      shippingDataLength: shippingAdFeesStore.getState().length,
    });
  }

  _getHttpRequestStore() {
    this.setState({
      httpRequestStore: HttpRequestStore.getState(),
    });
  }

  _getProductBatchStocksStore() {
    this.setState({
      productBatchStocksState: ProductBatchStocksStore.getState(),
    });
  }

  render() {
    const {
      ads,
      staticImagesUrl,
      onNotifyMeClick,
      onOpenFSFClick,
      onClickAddToCart,
      metroArea,
      showShowDetailsButton,
      onProductClick,
      currencyIsoCode,
      productType,
      onAlternativeProductStockClick,
      buyerAssistUrl,
    } = this.props;
    const { shippingData, shippingDataLength, httpRequestStore, productBatchStocksState } = this.state;
    if (!ads.length) {
      return null;
    }
    return (
      <>
        <div className="catalog-ads-product-parent">
          <div>
            {ads.map((ad) => {
              return (
                <div
                  className="catalog-product catalog-product--promoted"
                  style={{ width: '100%', border: 'none' }}
                  key={ad.sku}
                >
                  <AdTile
                    data={Object.assign({}, ad, {
                      stock: ad.stock || 0,
                      priceRrp: ad.priceRrp || '',
                      freeShipping: ad.freeShipping || false,
                      showFreeFitting: ad.showFreeFitting || false,
                      shippingTime: ad.shippingTime || '',
                      onNotifyMeClick: () => onNotifyMeClick(ad.sku),
                      onOpenFSFClick: () => onOpenFSFClick(ad.sku),
                      onClickAddToCart: () => onClickAddToCart(ad),
                      productType: productType,
                      staticImagesUrl: staticImagesUrl,
                      metroArea: metroArea,
                      showShowDetailsButton: showShowDetailsButton,
                      fittingPromotion: ad.fittingPromotion || null,
                      catalogAd: true,
                      priceDiscount: ad.priceDiscount,
                      customerAverageRatings: ad.customerAverageRatings,
                    })}
                    shippingFees={
                      <ShippingFees
                        productSku={ad.sku}
                        productType={productType}
                        stock={ad.stock}
                        shippingData={shippingData}
                        currencyIsoCode={currencyIsoCode}
                        staticImagesUrl={staticImagesUrl}
                        isSponsoredProduct={true}
                      />
                    }
                    shippingData={shippingData}
                    shippingDataHasValue={shippingDataLength > 0}
                    onProductClick={onProductClick}
                    currencyIsoCode={currencyIsoCode}
                    onSeeHowItWorksClick={this.props.onSeeHowItWorksClick}
                    httpRequestShippingFees={httpRequestStore.shipping_fees}
                    productBatchStocks={getProductBatchStock(ad.sku, productBatchStocksState)}
                    httpRequestProductBatchStocks={httpRequestStore.product_batch_stocks}
                    onAlternativeProductStockClick={onAlternativeProductStockClick}
                    buyerAssistUrl={buyerAssistUrl && buyerAssistUrl.replace('{spinach-id}', ad.sku)}
                    isRecommended={true}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}

function getProductBatchStock(productSku, productBatchStocksState) {
  let stocks = productBatchStocksState.productBatchStocks;
  let alternativeStocks = null;
  stocks.map((item) => {
    if (item.id.value !== productSku) return null;

    alternativeStocks = item;
  });

  return alternativeStocks;
}

CatalogAds.propTypes = {
  ads: PropTypes.array.isRequired,
  staticImagesUrl: PropTypes.string.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onNotifyMeClick: PropTypes.func.isRequired,
  onOpenFSFClick: PropTypes.func.isRequired,
  onClickAddToCart: PropTypes.func.isRequired,
  metroArea: PropTypes.string,
  showShowDetailsButton: PropTypes.bool,
  onProductClick: PropTypes.func.isRequired,
  onSeeHowItWorksClick: PropTypes.func.isRequired,
  productType: PropTypes.string,
  onAlternativeProductStockClick: PropTypes.func.isRequired,
  buyerAssistUrl: PropTypes.string,
};

export { CatalogAds };
